module.exports = __webpack_public_path__ + "static/media/consumidor-banner.f9aa8bb1.f9aa8bb1.JPG";